


























































































































































import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import TextInput from '~/components/Inputs/Text.vue';
import { EMAIL_PATTERN, NAMES_PATTERN } from '~/utils/constants/code';
import { SfRadio } from '@storefront-ui/vue';
import InformativaSintetica from '~/components/solepro/Consensi/InformativaSintetica.vue';
import ClientOnly from 'vue-client-only'

export default defineComponent({
  components: {
    TextInput,
    SfRadio,
    InformativaSintetica,
    ClientOnly
  },

  setup() {
    const email = ref()
    const firstname = ref()
    const lastname = ref()
    const consensoMail = ref(null)
    const openConsensoMail = ref(false)
    const consensoProfilazione = ref(null)
    const openConsensoProfilazione = ref(false)
    const consensoSocieta = ref(null)
    const openConsensoSocieta = ref(false)

    const origin = computed(() => {
      if (process.server) {
        return ''
      } else {
        return window.location.origin;
      }
    })
    const TYP = computed(() => origin.value + '/thank-you.html')
    const isFormValid = computed(() => {
      return !!(
        firstname.value && NAMES_PATTERN.test(firstname.value) &&
        lastname.value && NAMES_PATTERN.test(lastname.value) &&
        email.value && EMAIL_PATTERN.test(email.value) &&
        consensoMail.value !== null &&
        consensoProfilazione.value !== null &&
        consensoSocieta.value !== null
      );
    })
    return {
      email,
      firstname,
      lastname,
      EMAIL_PATTERN,
      NAMES_PATTERN,
      consensoMail,
      openConsensoMail,
      consensoProfilazione,
      openConsensoProfilazione,
      consensoSocieta,
      openConsensoSocieta,
      isFormValid,
      TYP
    }
  },

})
